import React from "react";
import { getServerEndpoint } from '../../utils/serverEndpoint';

let path = getServerEndpoint() + 'applicationresources' + '/';

export const ImageRenderer = ({ height, imgId }) => {
    return (
        <React.Fragment>
            {imgId && (
                <div>
                    <img height={height} src={path + imgId} alt="" />
                </div>
            )}
        </React.Fragment>
    );
};


// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ImageRenderer.jsx